<span class="dot-completed {{ colorClass }}"
  ><mat-icon class="check">check</mat-icon></span
>
